import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/Documents/integrated/ryly/app/City/[id]/CityComponent.js");
